const SectionTemplate = {
  title: 'New Section',
  shared: false,
  shouldRender: false,
  processed: false,
  background: {
    color: '#ffffff',
    image: {
      position: 'center',
      repeat: 'no-repeat',
      size: 'cover',
      url: ''
    }
  },
  widgets: [],
  menuClass: ''
}
export default SectionTemplate



// WEBPACK FOOTER //
// ./src/components/utils/templates/SectionTemplate.js